'use strict'

const NewsLoadMore = {
  ctx: $('.js-news-load-more'),
  targetContainer: $('.news__list'),
  targetElementIdentifier: '.news__item'
}

NewsLoadMore.init = function () {
  const uri = getNextPageUriFromPagination()

  // Check for valid link
  // On invalid link remove ctx
  if (uri === null || typeof uri === 'undefined' || uri === '') {
    unsetLoadingState(true)
    return
  }

  setNextPageUri(uri)

  NewsLoadMore.ctx.bind('click', function (e) {
    e.preventDefault()

    // Don't react on event if loading in progress
    if (NewsLoadMore.ctx.attr('data-loading') === 'yes') {
      return
    }

    setLoadingState()

    lazyLoad(getNextPageUriFromCtx(), function (result) {
      const newPagination = $(result).find('.page-navigation:first')
      const currentPagination = $('.page-navigation')
      const contentOld = NewsLoadMore.targetContainer.find(NewsLoadMore.targetElementIdentifier)
      const contentNew = $(result).find(NewsLoadMore.targetElementIdentifier)

      replacePagination(currentPagination, newPagination)

      // Clean up container
      NewsLoadMore.targetContainer.html("")

      // Add old news entries to container
      contentOld.each(function () {
        $(this).appendTo(NewsLoadMore.targetContainer)
      })

      // Add new news entries to container
      contentNew.each(function () {
        $(this).appendTo(NewsLoadMore.targetContainer)
      })

      const uri = getNextPageUriFromPagination()
      if (uri === null || typeof uri === 'undefined' || uri === '') {
        unsetLoadingState(true)
        return
      }

      setNextPageUri(uri)
      unsetLoadingState(false)
    })
  })
}

const getNextPageUriFromPagination = function () {
  const paginationNext = $('.f3-widget-paginator:first .next a')
  return (paginationNext.length <= 0) ? null : paginationNext.attr('href')
}

const getNextPageUriFromCtx = function () {
  return NewsLoadMore.ctx.attr('data-uri')
}

const setNextPageUri = function (uri) {
  NewsLoadMore.ctx.attr('data-uri', uri)
}

const lazyLoad = function (uri, callback) {
  $.ajax({
    url: uri,
    type: 'GET',
    success: callback
  })
}

const replacePagination = function (currentPagingation, newPagination) {
  currentPagingation.each(function (i, el) {
    $(el).replaceWith(newPagination.clone())
  })
}

const setLoadingState = function () {
  NewsLoadMore.ctx.attr('data-loading', 'yes')
  NewsLoadMore.ctx.addClass('is-loading')
}

const unsetLoadingState = function (remove) {
  if (remove === true) {
    NewsLoadMore.ctx.remove()
    return
  }

  NewsLoadMore.ctx.removeAttr('data-loading')
  NewsLoadMore.ctx.removeClass('is-loading')
}

export { NewsLoadMore }
